<template>
  <table class="client-min-version-range">
    <tr>
      <td>Max value (server version):</td>
      <td>{{clientVersionInfo.gameVersion}}</td>
    </tr>
    <tr>
      <td>Min value (forced version):</td>
      <td>{{clientVersionInfo.forcedVersion}}</td>
    </tr>
  </table>
</template>

<script>
import { ClientVersionInfo } from '../model/version.js';

export default {
  name: 'ClientVersion',

  props: {
    clientVersionInfo: {
      type: ClientVersionInfo,
      required: true,
    }
  },
};
</script>

<style scoped>
.client-min-version-range td:first-child {
  padding-right: 0.3rem;
}
</style>